import { render, staticRenderFns } from "./SubNav.vue?vue&type=template&id=24a1ae22&scoped=true&"
import script from "./SubNav.vue?vue&type=script&lang=js&"
export * from "./SubNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a1ae22",
  null
  
)

export default component.exports